import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/api/client";
import { toast } from "sonner";

export default function PasswordChangeDialog({ open, onOpenChange }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw !== confirm) { toast.error("Passwords don't match"); return; }
    if (newPw.length < 6) { toast.error("Password must be 6+ chars"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Password changed");
      setOldPw(""); setNewPw(""); setConfirm("");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Failed");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-white/10 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Change password</DialogTitle>
          <DialogDescription className="text-white/50">
            Set a new password for your account.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="overline">Current password</Label>
            <Input type="password" required value={oldPw} onChange={(e) => setOldPw(e.target.value)}
              data-testid="pwd-old-input" className="bg-black/40 border-white/10 mt-2 focus-visible:ring-red-500" />
          </div>
          <div>
            <Label className="overline">New password</Label>
            <Input type="password" required value={newPw} onChange={(e) => setNewPw(e.target.value)}
              data-testid="pwd-new-input" className="bg-black/40 border-white/10 mt-2 focus-visible:ring-red-500" />
          </div>
          <div>
            <Label className="overline">Confirm new password</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              data-testid="pwd-confirm-input" className="bg-black/40 border-white/10 mt-2 focus-visible:ring-red-500" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={saving}
              data-testid="pwd-submit-btn"
              className="bg-[#E11D2E] hover:bg-[#F03041] rounded-full px-6">
              {saving ? "Saving…" : "Update password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
